// Designs
export const DESIGNS = 'designs';

// Logout
export const LOGOUT = '/logout';

// Keywords
export const KEYWORDS = 'keywords';

// Tags
export const TAGS = 'tags';

// Categories
export const CATEGORIES = 'categories';

// Taxonomies
export const TAXONOMIES = 'taxonomies';

// Design Tagging Guidance
export const DESIGN_TAGGING_GUIDANCE = 'designTaggingGuidance';

export const ROOT = '/';
